import styled from "styled-components";

export const RefreshingListContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
